import {
  MDBBtn,
  MDBBtnGroup,
  MDBCheckbox,
  MDBDropdown,
  MDBDropdownItem,
  MDBDropdownMenu,
  MDBDropdownToggle,
  MDBIcon,
  MDBInput,
  MDBTimepicker,
} from "mdb-react-ui-kit";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import remove from "../components/images/remove.svg";
import CRPlans from "./CRPlans";

export default function CRScheduleDays(props) {
  return (
    <>
      <div className="d-flex align-items-center justify-content-between w-100 mt-3">
        <p className="m-0">{props.datelabel}</p>
        <div className="phoneselect">
          <CRPlans
            routingPlans={props.routingPlans}
            activePlan={props.activePlan}
            updatePlanValue={props.updatePlanValue}
            dayIndex={props.dayIndex}
          />
        </div>
      </div>
    </>
  );
}
